import _ from 'lodash';
import Analytics from '../../analytics';

import actions from '../../actions/product';

function CopyrightViolation(campaign) {
  this.campaign = campaign;
}

export default [
  '$rootScope', '$state', '$scope', '$interval', '$window', '$sce',
  '$location', '$filter', 'CampaignService', 'UrlHashParams', 'CartService', 'CampaignHistory', 'ProductsService', 'CurrencyService', 'AuthService', 'AbandonedCartService',
  class StoreCtrl {
    constructor($rootScope, $state, $scope, $interval, $window, $sce,
      $location, $filter, CampaignService, UrlHashParams, cartService, campaignHistory, productsService, CurrencyService, AuthService, AbandonedCartService, analytics = new Analytics()) {
      this._$rootScope = $rootScope;
      this._$scope = $scope;
      this._$window = $window;
      this._$sce = $sce;
      this._$location = $location;
      this._$filter = $filter;
      this._hash = UrlHashParams;
      this._productsService = productsService;
      this._preApplyCoupon = $state.params.coupon;
      this._abandonedCart = AbandonedCartService;
      this.analytics = analytics;
      this.username = $state.params.username;
      this.slug = $state.params.campaignSlug;
      this.campaign = null;
      this.endTime = {};
      this.copyrightViolation = false;
      this.descriptions = {};
      this.clockSizes = [{ val: "M", text: '8"' }, { val: "L", text: '11"' }];
      this.productChangedSize = false;

      $location.search('token', null);

      CampaignService.initializeSession(this.username, this.slug, $location.search());
      AuthService.getCurrentUser().then((res) => this.currentUser = res.user);
      this._handleOptOut($state.params.opt_out);

      this.cart = cartService;
      this.currency = CurrencyService;
      this.currency.init()
        .then(() => {
          if (this.campaign) this.productGroups(true);
        });

      this.productQuantities = ['1', '2', '3', '4', '5'];

      this.cart.init(this.username, this.slug)
        .then((data) => {
          this.campaign = data.campaign;
          this.copyrightViolation = data.violating_copyright;

          if (!this.copyrightViolation) {
            this._initCampaign(data);
            this._setEndTime($interval);
            this._setDefaultSelections();
            this._watchForGroupChange()
            this._watchForProductChange()
            this._watchForViewChange()
            this._watchForSizeChange()
            this._watchForQtyChange()
            campaignHistory.addItem(this.campaign, this.selectedProduct)

            if (this.campaign.status === 'ONLINE' && !this.campaign.has_expired) {
              this.analytics.sales(this.campaign, this.selectedProduct, this.hashCoupon);
            }
          }
        });

      $rootScope.$on('$stateChangeStart', function(e, to, toParams, from, fromParams) {
        if (to.name === 'sales-store' && from.name === 'checkout') {
          // hard reload if back button pressed from checkout page
          e.preventDefault();
          $window.location.href = `${toParams.username}/${toParams.campaignSlug}`;
        }
      });

      this.ticking = false;
      this.testBottom = 0;

      $(window).on('scroll', () => this._handleScroll());
      $(window).on('touchmove', () => this._handleScroll());
      $(window).on('resize', () => this._scrollUpdate());

      $scope.$on('$destroy', () => {
        $(window).off('scroll', () => this._handleScroll());
        $(window).off('touchmove', () => this._handleScroll());
        $(window).off('resize', () => this._scrollUpdate());
      });

      if (document.referrer && document.referrer.indexOf(`/store/${this.username}`) !== -1) this.showBackButton = true;
    }

    _handleScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => this._scrollUpdate());
      }
      this.ticking = true;
    }

    _scrollUpdate() {
      let cartControls = $('.cart__controls:first'),
        cartButtons = $('.cart__buttons:first'),
        windowBottom = $(window).scrollTop() + window.innerHeight;

      if (cartControls.length && cartButtons.length) {
        let cartFormBottom = cartControls.outerHeight() + cartControls.offset().top + cartButtons.height();

        if (windowBottom - cartFormBottom >= 0) cartButtons.addClass('cart__buttons--static');
        else cartButtons.removeClass('cart__buttons--static');
      }

      this.ticking = false;
    }

    goBackToStore() {
      this._$window.history.back();
    }

    campaignDescription() {
      return this._$sce.trustAsHtml(this.campaign.description);
    }

    campaignProgress() {
      let percentage = ((this.campaign.current_order_count / this.campaign.order_count_goal) * 100);
      if (percentage > 100) {
        percentage = 100;
      }
      return percentage + '%';
    }

    productGroups(forceUpdate) {
      let selectedThumbnail;

      this.groups = this.groups || [];

      if (forceUpdate) this.groups.length = 0;

      if (this.groups.length == 0) {
        _.each(_.unique(this.campaign.products, 'product.id'), product => {
          let thumbnail,
            view;

          if (this.selectedProduct && product.product.id === this.selectedProduct.product.id) {
            view = this.view || this.selectedProduct.default_side_to_display.toLowerCase();
            thumbnail = view === 'front' ? this.selectedProduct.assets.front_thumbnail : this.selectedProduct.assets.back_thumbnail;
          } else {
            view = this.view || product.default_side_to_display.toLowerCase();
            thumbnail = view === 'front' ? product.assets.front_thumbnail : product.assets.back_thumbnail
          }

          this.groups.push({
            label: `${product.product.name} - ${this._$filter('currency')((this.productPrice(product) * this.currency.info.conversion_rate), this.currency.info.currency_symbol)}`,
            id: product.product.id,
            thumbnail,
            group: product.product.group,
          });
        });
      }

      return this.groups;
    }

    handleClickProductThumbnail(group) {
      this.selectedGroup = group;
    }

    productColors() {
      let productID = this.selectedProduct.product.id;
      let products = _.filter(this.campaign.products, (p) => _.has(p, 'product.id') && p.product.id === productID);

      return products;
    }

    productSizes() {
      if (_.has(this, 'selectedProduct.product.sizes') && Array.isArray(this.selectedProduct.product.sizes)) {
        return this.selectedProduct.product.sizes;
      }
      return [];
    }

    productPrice(product) {
      let p = product || this.selectedProduct || {};
      if (typeof p.product === 'object') {
        let upcharge = p.product.upcharges[this.selectedSize] || 0;
        return parseFloat(p.selling_price) + parseFloat(upcharge);
      }
    }

    productMsrpPrice(product) {
      let p = product || this.selectedProduct || {};
      if (typeof p.product === 'object') {
        let upcharge = p.product.upcharges[this.selectedSize] || 0;
        return parseFloat(p.msrp) + parseFloat(upcharge);
      }
    }

    productSavings() {
      let savings = 100 - ((this.productPrice() / this.productMsrpPrice()) * 100);
      return Math.floor(savings);
    }

    addToCart(isValid) {
      if (isValid) {
        this.analytics.addToCart(this.campaign, this.selectedProduct, this.selectedQty, this.selectedSize);
        this.cart.add(this.selectedProduct, this.selectedSize, this.selectedQty);
        if (this._trackNewCart !== true) {
          this._abandonedCart.trackNewCart();
          this._trackNewCart = true;
        }
      } else {
        $('html,body').animate({
          scrollTop: $('.cart:first').offset().top
        }, 300);
      }
    }

    getShareURI() {
      return this._$location.absUrl();
    }

    selectedProductSizing() {
      if (!_.has(this, 'selectedProduct.product.id')) return false;
      let sd = this.descriptions[this.selectedProduct.product.id];
      if (!sd || sd.error || !sd.sizing) return false;
      return sd.sizing;
    }

    selectedProductDescription() {
      if (!_.has(this, 'selectedProduct.product.id')) return false;
      let sd = this.descriptions[this.selectedProduct.product.id];
      if (!sd || sd.error || !sd.description || sd.description == '') return false;
      return this._$sce.trustAsHtml(sd.description);
    }

    colorChangeEvent(product) {
      this.selectedProduct = product;
      this.analytics.changeColor(this.selectedProduct.product_color.name);
      this.productGroups(true);
    }

    isProductClock() {
      return actions.isProductClock(this.selectedProduct.product);
    }

    usOnlyProductInCart() {
      let usOnlyProduct = false;

      _.each(this.cart.contents(), cartProduct => {
        _.each(this.campaign.products, campaignProduct => {
          if (cartProduct.cpid === campaignProduct.id) {
            if (campaignProduct.product.us_only) usOnlyProduct = true;
            return false;
          }
        });
        if (usOnlyProduct) return false;
      });

      return usOnlyProduct;
    }

    _initCampaign(data) {
      // Ended?
      let end = moment.utc(this.campaign.end_date);
      let now = moment(new Date());
      this.ended = (end - now <= 0);
      this.currency.init().then(() => this.cart.setCountry(this.currency.info.country_code));

      if (this.campaign.cobrand_id) {
        this._$scope.$emit('partnership:showLogo', {
          pid: this.campaign.cobrand_id
        });
      }
    }

    _setEndTime($interval) {
      let end = moment.utc(this.campaign.end_date);
      let timer;

      timer = $interval(() => {
        let now = moment(new Date());
        if (end - now <= 0) {
          this.ended = true;
          $interval.cancel(timer);
          this.endTime = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
          };
          return;
        }

        let days = (end - now) / (1000 * 60 * 60 * 24);
        let hours = (days - Math.floor(days)) * 24;
        let minutes = (hours - Math.floor(hours)) * 60;
        let seconds = (minutes - Math.floor(minutes)) * 60;

        this.ended = false;
        this.endTime.days = Math.floor(days);
        this.endTime.hours = Math.floor(hours);
        this.endTime.minutes = Math.floor(minutes);
        this.endTime.seconds = Math.floor(seconds);

      }, 1001);
    }

    _setDefaultSelections() {
      let hash = this._hash.get();
      var search;

      let couponCode = this._$location.search().coupon;

      //
      // Coupon pre-apply
      if (hash['coupon']) {
        this.hashCoupon = decodeURIComponent(hash['coupon']);
        this.cart.applyCoupon(this.hashCoupon);
        this._hash.set('coupon', null);
      } else if (typeof this._preApplyCoupon === 'string' && this._preApplyCoupon !== '') {
        this.cart.applyCoupon(this._preApplyCoupon);
      }

      //
      // Product Selections
      if (hash['pid'] && hash['cid']) {
        search = _.find(this.campaign.products, (p) => _.get(p, 'product.id') == hash['pid'] && (_.get(p, 'color.id') == hash['cid'] || p.id == hash['cid']));
      } else if (hash['pid']) {
        search = _.find(this.campaign.products, (p) => _.get(p, 'product.id') == hash['pid']);
      } else if (hash['cid']) {
        search = _.find(this.campaign.products, (p) => _.get(p, 'color.id') == hash['cid']) || p.id == hash['cid'];
      }

      this.view = (actions.defaultProduct(this.campaign.products).default_side_to_display === 'BACK') ? 'back' : 'front';
      if (hash['sid'] === 'back' || hash['sid'] === 'front') this.view = hash['sid'];

      this.selectedProduct = (search !== undefined) ? search : actions.defaultProduct(this.campaign.products);
      this.selectedSize = this.selectedProduct.product.sizes.length > 1 ? null : this.selectedProduct.product.sizes[0];
      this.selectedQty = '1';
      this.selectedGroup = _.find(this.productGroups(), (group) => group.id === this.selectedProduct.product.id);
    }

    _watchForGroupChange() {
      this._$scope.$watch(() => this.selectedGroup, (group, oldGroup) => {
        // Prevent resetting product when watcher is first set.
        if (group.id === oldGroup.id) return;
        this.selectedProduct = _.find(this.campaign.products, (product) => product.product.id === group.id);

        // Select same size
        if (!this._sizeExists(this.selectedSize, this.productSizes())) {
          this.productChangedSize = true;
          this.selectedSize = this.selectedProduct.product.sizes.length > 1 ? null : this.selectedProduct.product.sizes[0];
        }

        this.productGroups(true);
      });
    }

    _watchForProductChange() {
      this._$scope.$watch(() => this.selectedProduct, (product) => {
        this._hash.set('pid', product.product.id);
        this._hash.set('cid', product.color.id);

        // Get Product Sizing Details
        if (typeof this.descriptions[product.product.id] === 'undefined') {
          this.descriptions[product.product.id] = {
            error: true
          };

          this._productsService.getSizingAndDescription(product.product.id)
            .then((res) => this.descriptions[product.product.id] = res);
        }
      });
    }

    _watchForSizeChange() {
      let set = false;

      this._$scope.$watch(() => this.selectedSize, () => {
        if (!set) set = true;
        else {
          if (!this.productChangedSize) this.analytics.changeSize(this.selectedSize);
          this.productChangedSize = false;
        }

        this.productGroups(true);
      });
    }

    _watchForQtyChange() {
      let set = false;
      this._$scope.$watch(() => this.selectedQty, () => {
        if (!set) set = true;
        else this.analytics.changeQuantity(this.selectedQty);
      });
    }

    _watchForViewChange() {
      this._$scope.$watch(() => this.view, (view) => this._hash.set('sid', view))
    }

    _sizeExists(size, sizeSet) {
      return !!_.find(sizeSet, (s) => size == s);
    }

    _handleOptOut(hash) {
      if (!hash) return;
      this._abandonedCart.optOutCart(hash).then(() => this.optOutSuccess = true);
    }

    //- holiday message
    holidayBusinessLogic() {
      return moment.utc(this.campaign.end_date).isBefore(moment.utc("2016-12-15 12:00:00"));
    }
    //- end holiday message
  }
];


// WEBPACK FOOTER //
// ./source/client/pages/store/store.ctrl.js